import filters from './filters';

export default filters;
